import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Button, Grid, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import PriceFactorsTable from './table';
import ProductCodeSelector from './productCodeSelector';
import PriceFactorsGroupSelector from './priceFactorsGroupSelector';
import './priceFactorsList.scss';

const INITIAL_STATE = {
  'productCode': '',
  'productGroup': '',
};

class PriceFactorsList extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.searchPriceFactorsInformation =
      this.searchPriceFactorsInformation.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PriceFactorsMaintenance,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.priceFactorsListUrl !== this.props.priceFactorsListUrl && this.props.priceFactorsListUrl) {
      downloadFile(this.props.priceFactorsListUrl);
      this.props.clearPriceFactorsListUrl();
    }
  }

  exportToExcel() {
    const urlParams = this.getParamExcelParams();
    this.props.downloadPriceFactorsList(urlParams);
  }

  getParamExcelParams() {
    const {productCode, productGroup} = this.state;
    const params = {
      'productCode': productCode,
      'priceFactorGroup': productGroup,
    };
    return params;
  }

  handleSearchClick() {
    this.searchPriceFactorsInformation();
  }

  handleFilterChange(event, target) {
    const {name, value} = target;
    const updatedState = {...this.state};
    updatedState[name] = value;
    this.setState(updatedState);
  }

  handleClearClick() {
    this.clearFilter();
    this.props.clearPriceFactorsList();
  }

  clearFilter() {
    this.setState(INITIAL_STATE);
  }

  searchPriceFactorsInformation() {
    const urlParams = this.getPriceFactorsQueryParams();
    this.props.getPriceFactorsList(urlParams);
  }

  getPriceFactorsQueryParams() {
    const {productCode, productGroup} = this.state;
    const {pageSize, pageNumber} = this.props;
    const params = {
      'productCode': productCode,
      'priceFactorGroup': productGroup,
      'limit': pageSize || 20,
      'offset': pageNumber || 0,
    };
    return params;
  }

  renderTitleAndActions() {
    return (
      <Card raised fluid>
        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de factores de precio</h2>
              <div className='title-bar-actions'>
                <div textalign='center'>{this.renderDownloadButton()}</div>
                <Button primary as={Link} to='/factores-de-precio/nuevo'>
                  Agregar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>

        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <h4>Product Code</h4>
              <ProductCodeSelector
                name='productCode'
                value={this.state.productCode}
                changeValue={this.handleFilterChange}
              />

              <h4>Grupo</h4>
              <PriceFactorsGroupSelector
                name='productGroup'
                value={this.state.productGroup}
                changeValue={this.handleFilterChange}
              />

              <div className='title-bar-actions'>
                <Button secondary onClick={this.handleClearClick}>
                  Limpiar
                </Button>

                <Button primary onClick={this.handleSearchClick}>
                  Buscar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>
      </Card>
    );
  }

  renderDownloadButton() {
    const {downloading, priceFactorsList} = this.props;
    const exportToExcelBtn = (
      <Button
        onClick={this.exportToExcel}
        secondary
        loading={downloading}
        disabled={downloading}
      >
        <Icon name='download' size='mini' />
        Excel
      </Button>
    );

    if (priceFactorsList.length !== 0) {
      return exportToExcelBtn;
    }

    return null;
  }

  render() {
    const {priceFactorsList} = this.props;
    return (
      <div className='price-factors'>
        {this.renderTitleAndActions()}
        <PriceFactorsTable
          priceFactorsList={priceFactorsList}
          onUpdate={this.searchPriceFactorsInformation}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'priceFactorsListLoading': state.priceFactorsList.loading,
    'pageNumber': state.priceFactorsList.offset,
    'pageSize': state.priceFactorsList.limit,
    'priceFactorsList': state.priceFactorsList.list,
    'priceFactorsListUrl': state.priceFactorsList.priceFactorsListUrl,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  getPriceFactorsList,
  clearPriceFactorsList,
  downloadPriceFactorsList,
  clearPriceFactorsListUrl,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  getPriceFactorsList,
  clearPriceFactorsList,
  downloadPriceFactorsList,
  clearPriceFactorsListUrl,
})(PriceFactorsList);
